import { render, staticRenderFns } from "./FilterSidebarBrands.vue?vue&type=template&id=3ef1518a&scoped=true"
import script from "./FilterSidebarBrands.vue?vue&type=script&lang=js"
export * from "./FilterSidebarBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef1518a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef1518a')) {
      api.createRecord('3ef1518a', component.options)
    } else {
      api.reload('3ef1518a', component.options)
    }
    module.hot.accept("./FilterSidebarBrands.vue?vue&type=template&id=3ef1518a&scoped=true", function () {
      api.rerender('3ef1518a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/FilterSidebarBrands.vue"
export default component.exports